<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'app',
}
</script>

<style>
*{
  padding: 0;
  margin: 0;
  border: 0;
  box-sizing: border-box;
  font-family: SourceHanSansCN-Regular,-apple-system,BlinkMacSystemFont,PingFang SC,Source Han Sans SC,Source Sans Pro,Noto Sans CJK SC,WenQuanYi Micro Hei,Arial,sans-serif;
}
#app{
  /* font-family: 'Avenir', Helvetica, Arial, sans-serif; */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
  height: 100%;
}
html,body{
  height: 100%;
}
ul,li {
  list-style: none;
}
button {
  border: none;
  background-color: transparent;
  outline: none;
}
</style>
